import { render, staticRenderFns } from "./WithdrawalRecordsTable.vue?vue&type=template&id=606db873&scoped=true"
import script from "./WithdrawalRecordsTable.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606db873",
  null
  
)

export default component.exports